import DOMPurify from "dompurify";

/**
 * Render trusted-but-rich HTML safely. Always sanitizes with DOMPurify.
 *
 * Use this instead of `dangerouslySetInnerHTML` anywhere in the app — that way
 * (a) future devs can't accidentally skip the sanitize call, and
 * (b) the static analyzers stop flagging the call sites as XSS risks.
 *
 * Props:
 *   - html: string of HTML to render (will be sanitized)
 *   - className, style, ...rest: forwarded to the wrapping <div>
 *   - tag: optional element tag, default "div"
 */
const SafeHtml = ({ html, tag = "div", className, style, ...rest }) => {
  const Tag = tag;
  return (
    <Tag
      className={className}
      style={style}
      {...rest}
      dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(html || "") }}
    />
  );
};

export default SafeHtml;
